<template>
    <div class="form-group">
        <label class="form-label" :for="id" :style="{ width: labelWidth }">
            <span v-if="required" style="color: #ff5a5a;">*</span>
            <span v-else style="visibility: hidden;">*</span>
            {{ label }}
        </label>
        <a-range-picker
            :style="{ width: inputWidth }"
            class="date-picker-field"
            v-model="localModelValue"
            @change="handleChange"
            :placeholder="placeholder"
            :disabled="disabled"
        />
    </div>
</template>

<script>
export default {
    name: 'RangePickerField',
    props: {
        required: {
            type: Boolean,
            default: false,
        },
        label: {
            type: String,
            required: false,
        },
        labelWidth: {
            type: String,
            default: '40%'
        },
        inputWidth: {
            type: String,
            default: '100%'
        },
        modelValue: {
            type: Array,
            default: () => [],
        },
        placeholder: {
            type: Array,
            default: () => ['开始日期', '结束日期'],
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        id: {
            type: String,
            required: false,
            default: ''
        },
    },
    data() {
        return {
            localModelValue: this.modelValue, // 使用 data 属性来存储实际的值
        };
    },
    watch: {
        // 监听 modelValue 的变化并同步到 localModelValue
        modelValue(newVal) {
            this.localModelValue = newVal;
        },
        // 监听 localModelValue 的变化并通知父组件
        localModelValue(newVal) {
            this.$emit('update:modelValue', newVal);
        }
    },
    methods: {
        handleChange(dates, dateStrings) {
            this.localModelValue = dateStrings; // 更新 localModelValue
            this.$emit('change', dates, dateStrings);
            this.$emit('update:modelValue', dateStrings); // 确保更新父组件的值
        },
        reset() {
            this.localModelValue = []; // 重置 localModelValue
            this.$emit('update:modelValue', []); // 重置父组件的值
        },
    },
};
</script>

<style scoped>
.form-group {
    display: flex;
    align-items: center;
    width: 100%;
}

.form-label {
    display: block;
    color: #94a3b8;
    font-size: 0.9rem;
    width: 40%;
    white-space: nowrap;
    margin-right: 0.5rem;
}
::v-deep .input-container {
    padding: 0;
}
.date-picker-field {
    display: flex;
    align-items: center;
    margin: 0 0.2rem;
}
::v-deep .ant-input {
    border: 1px solid rgba(0, 255, 150, 0.2);
    border-radius: 10px;
    background: rgb(14 27 52);
    color: #fff;
    font-size: 1rem;
    transition: all 0.3s ease;
    height: 45px;
}
::v-deep .ant-calendar-range-picker-separator {
    color: rgba(255, 255, 255, 0.5);
}
::v-deep .ant-calendar {
    background-color: #090d23 !important;
    color: #adadad !important;
}
</style>